import { BrowserRouter, Route, Routes } from "react-router-dom";
import { IRouteConfig } from "../models/IRouteConfig";
import { routesConfig } from "../configs/routes";
import Pages from "../pages";
import { useState } from "react";
import { useAppContext } from "@/store/appContext";

const Home = () => {
  const renderRoutes = (routes: IRouteConfig[]) => {
    return routes.map((route: IRouteConfig, index1: number) => (
      <Route key={index1} {...route}>
        {route.children && renderRoutes(route.children)}
      </Route>
    ));
  };
  return (
    <div className="flex flex-col w-full h-screen">
      <BrowserRouter>
        <Routes>
          <Route element={<Pages.Layout />}>{renderRoutes(routesConfig)}</Route>
        </Routes>
      </BrowserRouter>

      {/* <Pages.CookieConsent /> */}
    </div>
  );
};

export default Home;
